// extracted by mini-css-extract-plugin
export default {"bx":"orderareachart_bx__ZY-zf"};